import { render, staticRenderFns } from "./index.vue?vue&type=template&id=79671713&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/activity/vip/001.scss?vue&type=style&index=0&id=79671713&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79671713",
  null
  
)

export default component.exports